import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import { NavElements } from "../NavElements"

const NavData = graphql`
  {
    wpMenu(slug: { eq: "footer-columns-en" }) {
      menuItems {
        nodes {
          path
          label
          id
        }
      }
    }
  }
`

const EnglishColumnsNav = () => {
  const navData = useStaticQuery(NavData)
  const elements = navData.wpMenu.menuItems.nodes

  return <NavElements {...{ elements }} alignment="vertical" />
}

export default EnglishColumnsNav
